import React, { useState, useEffect } from 'react';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Space, Button } from "antd";
import Common from './includes/Common';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var DocumentView = function DocumentView(_ref) {
  var _ref$document = _ref.document,
    document = _ref$document === void 0 ? null : _ref$document;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      children: document == null ? /*#__PURE__*/_jsx("div", {
        style: {
          background: '#EEE',
          textAlign: 'center',
          padding: '200px 0px',
          color: '#9AA2A9'
        },
        children: /*#__PURE__*/_jsx("h2", {
          children: "PREVISUALISATION"
        })
      }) : /*#__PURE__*/_jsxs("div", {
        style: {
          background: '#EEE',
          textAlign: 'center',
          padding: '0px 0px'
        },
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            textAlign: 'center'
          },
          children: /*#__PURE__*/_jsx(Button, {
            type: "primary",
            href: document.location,
            target: "_blank",
            block: true,
            size: "small",
            children: /*#__PURE__*/_jsx("b", {
              children: "TELECHARGER"
            })
          })
        }), /*#__PURE__*/_jsx("h5", {
          children: /*#__PURE__*/_jsx("b", {
            children: document.title
          })
        }), /*#__PURE__*/_jsx("p", {
          children: document.description
        }), /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Auteur(e) : "
            }), document.user.prenom + " " + document.user.nom]
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Taille (mb) : "
            }), Math.round(document.size * 0.00001)]
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(DocViewer, {
          documents: [{
            uri: Common.baseUrl + document.location
          }],
          pluginRenderers: DocViewerRenderers,
          language: "fr",
          config: {
            header: {
              disableHeader: true,
              disableFileName: true
            }
          }
        })]
      })
    })
  });
};
export default DocumentView;